import { isSectionInView } from '../modules/isSectionInView';

const submenu = document.querySelector('.header-submenu');

if (submenu) {
    document.documentElement.classList.add('-higher');
    const sections = document.querySelectorAll('section');
    const footer = document.querySelector('footer');
    const items = submenu.querySelectorAll('.header-submenu__item');
    const overflowElement = submenu.querySelector('.header-submenu__items');

    if (sections.length > 0) {
        const showSubmenu = () => {
            submenu.classList.add('-active');
        };

        const hideSubmenu = () => {
            submenu.classList.remove('-active');
        };

        let scrollTimeout;

        const scrollInOverflowWrapper = key => {
            if (window.innerWidth > 991.98) return;

            clearTimeout(scrollTimeout);

            scrollTimeout = setTimeout(() => {
                let offset = 0;

                if (key > 0) {
                    for (let i = 0; i < items.length; i++) {
                        if (i >= key) break;
                        offset += items[i].offsetWidth;
                    }
                }

                overflowElement.scrollTo({
                    left: offset === 0 ? 0 : offset + 16,
                    behavior: 'smooth',
                });
            }, 100); // 100ms debounce – you can tweak this
        };

        const handleSubmenuItemsClasses = (
            target,
            lastViewedSectionId = ''
        ) => {
            if (!target || items.length === 0) return;
            items.forEach(item => item.classList.remove('-active'));
            items.forEach((item, key) => {
                const itemSubmenuId = item.getAttribute('data-submenu-item-id');
                if (itemSubmenuId == lastViewedSectionId) {
                    item.classList.add('-active');
                    setTimeout(() => {
                        scrollInOverflowWrapper(key);
                    }, 0);
                }
            });
        };

        const handleFirstSectionIntersection = (entries, observer) => {
            entries.forEach(entry => {
                if (!entry.isIntersecting) {
                    showSubmenu();
                } else {
                    hideSubmenu();
                }
            });
        };

        const showSubmenuObserver = new IntersectionObserver(
            handleFirstSectionIntersection,
            {
                root: null,
                rootMargin: '0px',
                threshold: 0.2,
            }
        );

        showSubmenuObserver.observe(sections[0]);
        let lastViewedSectionId = '';
        let showedFooter = false;

        let lastScrollTop = 0;

        window.addEventListener('scroll', e => {
            if (isProgrammaticScroll) return;

            const scrollTop =
                window.pageYOffset || document.documentElement.scrollTop;
            const scrollingDown = scrollTop > lastScrollTop;
            const scrollingUp = scrollTop < lastScrollTop;
            lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;

            sections.forEach(section => {
                lastViewedSectionId = section.getAttribute('id');

                if (isSectionInView(section, 0, 40) && !showedFooter) {
                    handleSubmenuItemsClasses(section, lastViewedSectionId);
                }

                if (isSectionInView(footer, 0, 50)) {
                    lastViewedSectionId = '';
                    showedFooter = true;
                    handleSubmenuItemsClasses(section, lastViewedSectionId);
                } else {
                    showedFooter = false;
                }
            });

            if (scrollingDown) {
                submenu.classList.add('-scrolling-down');
            } else if (scrollingUp) {
                submenu.classList.remove('-scrolling-down');
            }
        });

        let isProgrammaticScroll = false;
        // Update your click handler
        items.forEach((item, key) => {
            item.addEventListener('click', e => {
                e.preventDefault();
                const id = e.currentTarget.getAttribute('data-submenu-item-id');
                const sectionWithId = Array.from(sections).filter(
                    item => item.getAttribute('id') == id
                );

                if (sectionWithId.length > 0) {
                    const url = window.location.href;
                    const myOldUrl = url.includes('#')
                        ? url.substring(0, url.indexOf('#'))
                        : url;
                    window.history.pushState({}, null, myOldUrl + '#' + id);

                    isProgrammaticScroll = true;

                    handleSubmenuItemsClasses(sectionWithId[0], id); // Manually trigger once for clicked

                    window.scrollTo({
                        top:
                            sectionWithId[0].getBoundingClientRect().top +
                            window.scrollY -
                            180,
                        behavior: 'smooth',
                    });

                    setTimeout(() => {
                        isProgrammaticScroll = false;
                    }, 600); // Adjust depending on scroll duration
                }
            });
        });
    }
}
